import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { I as IMAGE_UPLOAD, G as GET_ALL_TAGS, S as SEARCH_FAILED, j as SEARCH_SUCCESS, F as FETCH_POSTS, k as FETCH_POST, l as SET_FILTER, m as SET_IS_POST_LOADING, N as NEW_POST, n as SELECT_POST } from './post.actions-dcd472e5.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var initialState = {
  page_size: 1,
  page: 0,
  total_pages: 1,
  total_items: 1,
  filter: {},
  items: [],
  item: {},
  tags: [],
  currentPost: {},
  clearForm: true,
  ok: true,
  message: '',
  image: null,
  errors: [],
  isPostLoading: false
};
function reducer () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case NEW_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        item: action.payload,
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message
      });

    case SELECT_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPost: action.payload
      });

    case NEW_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        item: action.payload
      });

    case SET_IS_POST_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isPostLoading: action.payload
      });

    case SET_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter: action.payload
      });

    case FETCH_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPost: action.payload.post,
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message,
        isPostLoading: false
      });

    case FETCH_POSTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: action.payload.data,
        page_size: action.payload.page_size,
        page: action.payload.page,
        total_pages: action.payload.total_pages,
        total_items: action.payload.total_items,
        ok: action.payload.ok,
        message: action.payload.message,
        errors: action.payload.errors
      });

    case SEARCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        items: action.payload.data,
        message: action.payload.message
      });

    case SEARCH_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message
      });

    case GET_ALL_TAGS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message,
        tags: action.payload.tags
      });

    case IMAGE_UPLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message,
        image: action.payload.image
      });

    default:
      return state;
  }
}

export { reducer as r };
